<div class="pill">
  <ng-content />
</div>
@if (messageMetadata) {
  <div [class.show]="isMetadataPresented" class="metadata">
    {{ messageMetadata }}
  </div>
}
